import Footer from "./Components/Footer";
import NavBar from "./Components/NavBar";
import ScrollToTopButton from "./Components/ScrollToTopButton";
import Routing from "./Routing/Routing";
import SEO from "./Components/SEO";
import NewAnnouncements from "./Components/NewAnnouncements";
import { useLocation } from "react-router-dom";




function App() {
  const { pathname } = useLocation();
 
  return (
    <div className="App min-h-screen">
      <SEO />
<NavBar/>
<main className="glass-panel mx-3 mt-3 rounded-2xl">
<Routing/>
</main>
{pathname === "/" && <NewAnnouncements/>}
<ScrollToTopButton/>
<Footer/>
    </div>
  );
}

export default App;
